<template>
    <b-v-form-btn-label-control
        ref="control"
        :button-only="responsiveness"
        :value="formattedValue"
        :state="state"
        :placeholder="placeholder"
        :class="variant"
    >
        <b-calendar
            v-on="listeners"
            v-bind="attrs"
            :value="value"
            @input="handleValueChange"
            @selected="handleValueSelect"
            ref=""
        >
            <div class="d-flex" dir="rtl" v-if="resetButton">
                <b-button size="sm" variant="outline-danger" :disabled="!value" @click="clearDate"> Reset </b-button>
            </div>
        </b-calendar>
        <template v-slot:button-content="buttonSlotProps" variant="primary">
            <b-icon-calendar-fill
                v-if="buttonSlotProps.isHovered || buttonSlotProps.hasFocus"
                :aria-hidden="true"
                :scale="1.25"
                class="primary-icon"
            ></b-icon-calendar-fill>
            <b-icon-calendar v-else :aria-hidden="true" :scale="1.25" class="primary-icon"></b-icon-calendar>
        </template>
    </b-v-form-btn-label-control>
</template>

<script>
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';
    import { BVFormBtnLabelControl } from 'bootstrap-vue/src/components/form-btn-label-control/bv-form-btn-label-control';
    import { BIconCalendar, BIconCalendarFill, BButton } from 'bootstrap-vue';

    export default {
        name: 'Datepicker',
        components: {
            BIconCalendar,
            BIconCalendarFill,
            BVFormBtnLabelControl,
            BButton,
        },
        inheritAttrs: false,
        props: {
            value: {
                type: [String, Date],
                default: null,
            },
            displayFormat: {
                type: String,
                default: 'MM/dd/yyyy',
            },
            resetButton: {
                type: Boolean,
                default: false,
            },
            emptyValue: {
                type: String,
                default: '',
            },
            state: {
                type: Boolean,
                default: null,
            },
            variant: {
                type: String,
                default: '',
            },
            responsiveness: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: 'No date selected',
            },
        },
        computed: {
            formattedValue() {
                return !!this.value ? format(parseISO(this.value), this.displayFormat) : this.emptyValue;
            },
            attrs() {
                return Object.assign({}, this.$attrs);
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
        methods: {
            handleValueChange(value) {
                this.$emit('input', value || this.emptyValue);
                this.$emit('modelCompat:input', value || this.emptyValue);
            },
            handleValueSelect(value) {
                this.$emit('selected');
                this.$nextTick(() => {
                    this.$refs.control.hide(true);
                });
            },
            clearDate() {
                this.$emit('input', this.emptyValue);
                this.$refs.control.hide(true);
            },
            show() {
                this.$refs.control.show();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .primary {
        background-color: #0d47a1 !important;
        border-color: #0d47a1 !important;
        border-radius: 0.25rem;
        &.focus {
            background-color: #0d47a1 !important;
            border-color: #0d47a1 !important;
        }
        &:hover {
            background-color: #0a377e !important;
            border-color: #093272 !important;
        }
        :deep(label) {
            color: white !important;
        }
        :deep(> button) {
            color: white !important;
            background-color: transparent !important;
            border-color: transparent !important;
        }
    }

    :deep(label) {
        box-shadow: none !important;
    }

    :deep(.btn) {
        background-color: #0d47a1;
        color: #fff;
    }
</style>
